const VERSION = '1.1.11';
export default VERSION;
